<template>
  <div class="page_1" :style="{overflow: visible ? 'hidden' : 'auto'}">
      <div class="list">
        <cube-swipe v-if="!shareType">
            <li class="swipe-item-wrapper" v-for="(data,index) in swipeData" :key="data.item.id">
              <BurtSwipeItem
                  ref="swipeItem"
                  :btns="data.btns"
                  :index="index"
                  @btn-click="onBtnClick">
                <div @click="onItemClick(data.item, index)" class="item-inner">
                  <div class="item">
                    <div class="proImg_">
                      <template v-if="data.item.imgurl.length == 2">
                        <div style="width: 70px;">
                          <img :src="data.item.imgurl[0]" alt="" class="first_img">
                        </div>
                        <div>
                          <img :src="data.item.imgurl[1]" alt="" class="four_img">
                        </div>
                      </template>
                      <template v-else-if="data.item.imgurl.length == 3">
                        <div class="img_style">
                          <img :src="data.item.imgurl[0]" alt="" class="first_img">
                          <img :src="data.item.imgurl[1]" alt="" class="second_img">
                        </div>
                        <img :src="data.item.imgurl[2]" alt="" class="center_img">
                      </template>
                      <template v-else-if="data.item.imgurl.length == 4">
                        <div class="img_style">
                          <img :src="data.item.imgurl[0]" alt="" class="first_img">
                          <img :src="data.item.imgurl[1]" alt="" class="second_img">
                        </div>
                        <img :src="data.item.imgurl[2]" alt="" class="third_img">
                        <img :src="data.item.imgurl[3]" alt="" class="four_img">
                      </template>
                      <img :src="img" alt="" v-for="(img,index) in data.item.imgurl" :key="index" v-else>
                    </div>
                    <div class="right_" :class="{right_1 : data.item.imgurl.length == 1}">
                      <div class="title">
                        <span class="left">{{data.item.combinationName}}</span>
                        <span class="right">查看组合</span>
                      </div>
                      <p class="content">{{data.item.desc | filterContent}}</p>
                    </div>
                  </div>
                </div>
              </BurtSwipeItem>
            </li>
        </cube-swipe>
        <div v-else>
          <div class="swipe-item-wrapper" v-for="(data,index) in swipeData" :key="data.item.id">
            <div @click="onItemClick(data.item, index)" class="item-inner">
                  <div class="item">
                    <div class="proImg_">
                      <template v-if="data.item.imgurl.length == 2">
                        <div style="width: 70px;">
                          <img :src="data.item.imgurl[0]" alt="" class="first_img">
                        </div>
                        <div>
                          <img :src="data.item.imgurl[1]" alt="" class="four_img">
                        </div>
                      </template>
                      <template v-else-if="data.item.imgurl.length == 3">
                        <div class="img_style">
                          <img :src="data.item.imgurl[0]" alt="" class="first_img">
                          <img :src="data.item.imgurl[1]" alt="" class="second_img">
                        </div>
                        <img :src="data.item.imgurl[2]" alt="" class="center_img">
                      </template>
                      <template v-else-if="data.item.imgurl.length == 4">
                        <div class="img_style">
                          <img :src="data.item.imgurl[0]" alt="" class="first_img">
                          <img :src="data.item.imgurl[1]" alt="" class="second_img">
                        </div>
                        <img :src="data.item.imgurl[2]" alt="" class="third_img">
                        <img :src="data.item.imgurl[3]" alt="" class="four_img">
                      </template>
                      <img :src="img" alt="" v-for="(img,index) in data.item.imgurl" :key="index" v-else>
                    </div>
                    <div class="right_" :class="{right_1 : data.item.imgurl.length == 1}">
                      <div class="title">
                        <span class="left">{{data.item.combinationName}}</span>
                        <span class="right">查看组合</span>
                      </div>
                      <p class="content">{{data.item.desc | filterContent}}</p>
                    </div>
                  </div>
            </div>
            </div>
        </div>
        
      </div>
      <div class="mask" v-show="showMask" @click="hideMask">
        <img src="../../../assets/image/nsale/guide.png" alt="">
      </div>
      <div class="fix_bg" v-if="visible">
        <div class="box">
            <div class="top">
              <p class="p_item">
                <label>组合名称</label>
                <textarea placeholder="请输入组合名称" v-model="combinationName" :disabled="readOnly"></textarea>
              </p>
              <p class="p_item">
                <label>分享标题</label>
                <textarea placeholder="请输入分享链接标题" v-model="shareTitle" :disabled="readOnly"></textarea>
              </p>
              <p class="p_item">
                <label>分享文案</label>
                <textarea placeholder="请输入分享文案" v-model="shareContent" :disabled="readOnly"></textarea>
              </p>
              <div class="p_item">
                <label>组合海报（点击后可长按保存）</label>
                <div class="post_imgs">
                  <div class="post_img">
                    <vue-canvas-poster
                      :widthPixels="105"
                      :painting="painting"
                      @success="success"
                      @fail="fail"
                    ></vue-canvas-poster>
                    <img :src="posterImg" class="post_img" @click="scalePostImgClick(0)"/>
                  </div>
                  <div class="post_img">
                    <vue-canvas-poster
                      :widthPixels="105"
                      :painting="painting2"
                      @success="success2"
                      @fail="fail2"
                    ></vue-canvas-poster>
                    <img class="post_img" :src="posterImg2" @click="scalePostImgClick(1)"/>
                  </div>
                  <div class="post_img">
                    <vue-canvas-poster
                      :widthPixels="105"
                      :painting="painting3"
                      @success="success3"
                      @fail="fail3"
                    ></vue-canvas-poster>
                    <img class="post_img" :src="posterImg3" @click="scalePostImgClick(2)"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom">
              <button @click="visible = false">取消</button>
              <div class="empty"  v-if="!readOnly"></div>
              <button class="confirm_btn" @click="onItemUpdate" v-if="!readOnly">确定</button>
            </div>
          </div>
      </div>
      <div class="scale_poster" v-if="isShowScaleFlag" @click="isShowScaleFlag = false">
        <div class="inner_scale_poster">
          <div>
            <vue-canvas-poster
              :widthPixels="2000"
              :painting="scalePainting"
              @success="scaleSuccess"
              @fail="scaleFail"
            ></vue-canvas-poster>
            <img :src="scalePosterImg" @click="scalePostImgClick(posterImg)"/>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import BurtSwipeItem from '@/components/cube-ui-swipe-item.vue';
export default {
  data() {
    document.title = '我的常用组合推广'
    return {
      readOnly: false,
      list: [],
      tabList: ["全部"],
      typeIdList: [],
      columnIndex: 0,
      queryParam: {
        start: 1,
        length: 10,
        noPage: 1
      },
      query: {},
      productIds: [],
      data: [],
      height: '',
      showBar: false,
      showMask: false,
      userId: '',
      avatarUrl: '',
      swipeData: [],
      visible: false,
      btnClickData: {},
      combinationName: '',
      shareTitle: '',
      shareContent: '',
      shareType: '',
      posterImg: [], //生成的海报
      painting: {
        width: "105px",
        height: "159px",
        background: "",
        views: [
          {
            type: "image",
            url: "",
            css: {
              top: "20px",
              left: "36px",
              borderRadius: "40px",
              width: "80px",
              height: "80px",
            },
          },
          {
            type: "text",
            text: "",
            css: {
              top: "48px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
            },
          },
          {
            type: "qrcode",
            content: "",
            css: {
              bottom: "7px",
              right: "5px",
              color: "#000",
              background: "#fff",
              width: "24px",
              height: "24px",
              borderWidth: "1px",
              borderColor: "#fff",
            },
          },
        ],
      },
      posterImg2: [], //生成的海报
      painting2: {
        width: "105px",
        height: "159px",
        background: "",
        views: [
          {
            type: "image",
            url: "",
            css: {
              top: "20px",
              left: "36px",
              borderRadius: "40px",
              width: "80px",
              height: "80px",
            },
          },
          {
            type: "text",
            text: "",
            css: {
              top: "48px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
            },
          },
          {
            type: "qrcode",
            content: "",
            css: {
              bottom: "7px",
              right: "5px",
              color: "#000",
              background: "#fff",
              width: "24px",
              height: "24px",
              borderWidth: "1px",
              borderColor: "#fff",
            },
          },
        ],
      },
      posterImg3: [], //生成的海报
      painting3: {
        width: "105px",
        height: "159px",
        background: "",
        views: [
          {
            type: "image",
            url: "",
            css: {
              top: "20px",
              left: "36px",
              borderRadius: "40px",
              width: "80px",
              height: "80px",
            },
          },
          {
            type: "text",
            text: "",
            css: {
              top: "48px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
            },
          },
          {
            type: "qrcode",
            content: "",
            css: {
              bottom: "7px",
              right: "5px",
              color: "#000",
              background: "#fff",
              width: "24px",
              height: "24px",
              borderWidth: "1px",
              borderColor: "#fff",
            },
          },
        ],
      },
      postImgList: [
        'http://test-ssish.oss-cn-hangzhou.aliyuncs.com/core/wxstore/post1.jpg',
        'http://test-ssish.oss-cn-hangzhou.aliyuncs.com/core/wxstore/post2.jpg',
        'http://test-ssish.oss-cn-hangzhou.aliyuncs.com/core/wxstore/post3.jpg'
      ],
      scalePostImg: '',
      isShowScaleFlag: false,
      scalePosterImg: [], //放大的海报
      scalePainting: {
        width: "900px",
        height: "1230px",
        background: "",
        views: [
          {
            type: "image",
            url: "",
            css: {
              top: "20px",
              left: "36px",
              borderRadius: "1px",
              width: "300px",
              height: "410px",
            },
          },
          {
            type: "text",
            text: "",
            css: {
              top: "48px",
              left: "136px",
              width: "360px",
              maxLines: 1,
              fontSize: "26px",
            },
          },
          {
            type: "qrcode",
            content: "",
            css: {
              bottom: "50px",
              right: "33px",
              color: "#000",
              // background: "#fff",
              width: "213px",
              height: "195px",
              borderWidth: "1px",
              borderColor: "#fff",
            },
          },
        ],
      },
      jumpUrl: ''
    }
  },
  components: {
    BurtSwipeItem
  },
  created() {
    this.query = this.$route.query
    this.userId = this.query.userId
    // 分享出去的链接不能操作
    this.shareType = this.$route.query.shareType
    window.addEventListener('scroll',this.handleScroll,true)
    this.getProductCombinationSpread()
    this.activeIndex = -1
    this.queryUser()
    this.fetchJsSdkSign()
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  filters: {
    filterContent (value) {
      if (!value) return ''
      if (value.length > 60) {
        return value.slice(0,60) + '...'
      }
      return value 
    },
  },
  methods: {
    onItemUpdate() {
      if (!this.combinationName) {
        window.$toast('请输入组合名称')
        return false
      }
      let id = this.btnClickData.id
      let data = {
        combinationName: this.combinationName,
        shareTitle: this.shareTitle,
        shareContent: this.shareContent
      }
      this.updateProductCombinationSpread(id,data)
    },
    onItemClick(item) {
      console.log('click item:', item)
      var origin = 'http://mall.run4wd.com'
      if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
        origin = 'http://nyboss.yutai365.com'
      }
      if (item.id) {
        window.location.href = `${origin}/m/bs/extension?userId=${this.query.userId}&appId=${this.query.appId}&mainId=${this.query.mainId}&productTransactionCodes=${item.productTransactionCodes}&queryId=${item.id}`
      } else {
        window.location.href = `${origin}/m/bs/extension?userId=${this.query.userId}&appId=${this.query.appId}&mainId=${this.query.mainId}&productTransactionCodes=${item.productTransactionCodes}&wxComConfId=${item.wxComConfId}`
      }
    },
    onBtnClick(btn, index) {
      let param = this.swipeData[index].item
      console.log(param, 438)
      if (param.wxComConfId && !param.id) {
        if(btn.action === 'delete') {
          window.$toast('该组合为官方推荐组合，不可删除')
          return
        }
      }
      if (btn.action === 'delete') {
        this.$createActionSheet({
          title: '确认要删除吗',
          active: 0,
          data: [
            {content: '删除'}
          ],
          onSelect: () => {
            this.delProductCombinationSpread(param.id)
          }
        }).show()
      } else if (btn.action == 'modifyName') {
        debugger
        this.visible = true;
        if (param.wxComConfId) {
          this.readOnly = true;
        } else {
          this.readOnly = false;
        }
        this.btnClickData = param
        this.combinationName = param.combinationName
        this.shareTitle = param.shareTitle
        this.shareContent = param.shareContent

        var origin = 'http://mall.run4wd.com'
        if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
          origin = 'http://nyboss.yutai365.com'
        }
        if (param.id) {
          this.jumpUrl = `${origin}/m/bs/extension?userId=${this.query.userId}&appId=${this.query.appId}&mainId=${this.query.mainId}&productTransactionCodes=${param.productTransactionCodes}&queryId=${param.id}`
        } else {
          this.jumpUrl = `${origin}/m/bs/extension?userId=${this.query.userId}&appId=${this.query.appId}&mainId=${this.query.mainId}&productTransactionCodes=${param.productTransactionCodes}&wxComConfId=${param.wxComConfId}`
        }
        this.initPostImgs()

      } else {
        let origin = "http://wx.run4wd.com";
        if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
          origin = "http://wx.ssish.com"
        }
        window.location.href = `${origin}/authority/wxstore/moreProduct?searchValue=&from=front&queryId=${param.id}&wxComConfId=${param.wxComConfId}`
      }
    },
    onItemActive(index) {
      if (index === this.activeIndex) {
        return
      }
      if (this.activeIndex !== -1) {
        const activeItem = this.$refs.swipeItem[this.activeIndex]
        activeItem.shrink()
      }
      this.activeIndex = index
    },
    delProductCombinationSpread(id) {
      api.delProductCombinationSpread(id).then(res => {
        window.$toast('删除成功')
        this.getProductCombinationSpread()
      })
    },
    updateProductCombinationSpread(id,data) {
      this.visible = false
      api.updateProductCombinationSpread(id,data).then(res => {
        window.$toast('修改成功')
        this.getProductCombinationSpread()
      })
    },
    getProductCombinationSpread() {
      this.swipeData = []
      api.getProductCombinationSpread(this.query).then(res => {
        let productList = res.data.content.productCombinationSpreadList
        let combinationDetails = res.data.content.combinationDetails
        productList.forEach(item => {
          let content = ''
          let imgList = []
          let details = item.id ? combinationDetails[`my${item.id}`] : combinationDetails[`wx${item.wxComConfId}`]
          if (details != null && details.length > 0) {
            details.forEach((detail, index) => {
              content += detail.productName
              if (details.length -1 != index) {
                content += '、'
              }
              if (imgList.length < 4) {
                imgList.push(detail.productPicuter)
              }
            })
          }
          let btns = [];
          if (item.wxComConfId && !item.id) {
            btns = [
              {
              action: 'modifyName',
              text: '查看名称及分享信息',
              color: '#FF7D6E',
            },
            {
              action: 'delete',
              text: '删除',
              color: '#ccc',
            }]
          } else {
            btns = [
              {
              action: 'modify',
              text: '修改',
              color: '#FF7D6E',
            },
            {
              action: 'modifyName',
              text: '修改名称及分享信息',
              color: '#c8c7cd',
            },
            {
              action: 'delete',
              text: '删除',
              color: '#FF7D6E',
            }]
          }
          let data = {
            item: {
              ...item,
              desc: content,
              imgurl: imgList,
            },
            btns
          }
          this.swipeData.push(data)
        })
        console.log(this.swipeData, 541);
      })
    },
    queryUser() {
      api.queryUser({userId: this.userId}).then(res => res.data).then(data => {
        const { imageUrl } = data.content
        this.avatarUrl = imageUrl
      })
    },
    fetchJsSdkSign() {
      let url = location.href.split("#")[0];
      this.linkurl = url;
      api
        .getJsJdkSign2({
          url: url,
          userId: this.userId
        })
        .then(res => res.data)
        .then(async data => {
          const { appId, jssdkReqData } = data;
          console.log(appId, jssdkReqData);
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ['hideOptionMenu', 'showOptionMenu']
          }
          const { wxHideMenu } = await this.$wx.wxConfig(options)
          wxHideMenu()
        });
    },
    goShare(item) {
      var origin = 'http://mall.run4wd.com'
      if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
        origin = 'http://nyboss.yutai365.com'
      }
      window.location.href = origin + '/m/bs/extension?userId='+this.query.userId+ '&appId=' + this.query.appId + '&mainId=' + this.query.mainId + '&productTransactionCodes='+item.productTransactionCodes
    },
    changeTab(index,tabName) {
      this.list = []
      this.data.forEach(item => {
        if(tabName == '全部') {
          this.list = this.data
        }
        else if (item.productClassName == tabName) {
          this.list.push(item)
        }
      })
      this.columnIndex = index
    },
    queryProductItems() {
            
    },
    handleScroll(e) {
      var top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset)
      this.height=top
    },
    extension() {
      this.showMask = true
    },
    hideMask() {
      this.showMask = false
    },
    success(src) {
      this.posterImg = src;
    },
    fail(err) {
      alert(err);
    },
    success2(src) {
      this.posterImg2 = src;
    },
    fail2(err) {
      alert(err);
    },
    success3(src) {
      this.posterImg3 = src;
    },
    fail3(err) {
      alert(err);
    },
    initPostImgs() {
      this.painting.background = this.postImgList[0]
      this.painting.views.forEach((view) => {
        if (view.type == "qrcode") {
            view.content = this.jumpUrl
        }
      });

      this.painting2.background = this.postImgList[1]
      this.painting2.views.forEach((view) => {
        if (view.type == "qrcode") {
            view.content = this.jumpUrl
        }
      });

      this.painting3.background = this.postImgList[2]
      this.painting3.views.forEach((view) => {
        if (view.type == "qrcode") {
            view.content = this.jumpUrl
        }
      });

    },
    scalePostImgClick(index) {
      this.isShowScaleFlag = true
      this.scalePainting.background = this.postImgList[index]
      this.scalePainting.views.forEach((view) => {
        if (view.type == "qrcode") {
            view.content = this.jumpUrl
        }
      });
    },
    scaleSuccess(src) {
      this.scalePosterImg = src;
    },
    scaleFail(err) {
      alert(err);
    },
  },
  watch: {
    height: {
      handler(newHeight,oldHeight) {
        if (newHeight > 40) {
          this.showBar = true
        } else {
          this.showBar = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page_1 {
  margin: 0 auto;
  height: 100vh;
  .tit_ {
    height: 44px;
    line-height: 44px;
    background-color: #fff;
    font-size: 16px;
    color: #333;
    text-align: center;
    position: relative;
    &::before {
      content: 'X';
      position: absolute;
      left: 20px;
    }
  }
  .con {
    background-color: #fff;
    height: 40px;
    line-height: 40px;
    width: 100%;
    display:flex;
    .tab {
      font-weight: 500;
      font-size:15px;
      height:100%;
      flex: 1;
      
    }
    .active {
      font-weight: 700;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        display: block;
        width: 11px;
        height: 2px;
        border-radius: 4px;
        background-color: var(--main-color);
        transform: translateX(-50%);
    }
    }
  }
  .list {
      margin: 15px 15px 0;
      .item {
        background-color: #F8F8F8;
        border-radius: 7px;
        display: flex;
        height: 90px;
        margin-bottom: 10px;
        position: relative;
        padding: 10px;
        .proImg_ {
          display: flex;
          flex-direction: column;
          width: 70px;
          height: 100%;
          position: relative;
          img {
            width: 70px;
            border-radius: 7px;
          }
          .first_img {
            position: absolute;
            width: 35px;
            height: 35px;
            left: 0;
            top: 0;
          }
          .second_img {
            position: absolute;
            width: 35px;
            height: 35px;
            top: 0;
            left: 35px;
          }
          .third_img {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 35px;
            height: 35px;
          }
          .four_img {
            position: absolute;
            bottom: 0;
            left: 35px;
            width: 35px;
            height: 35px;
          }
          .center_img {
            position: absolute;
            bottom: 0;
            left: 15px;
            width: 35px;
            height: 35px;
          }
          .img_style {
            width: 70px;
            display: flex;
            justify-content: space-between;
          }
        }
        .right_ {
          text-align: left;
          margin-left: 10px;
          width: 245px;
          .title {
            display: flex;
            height: 20px;
            line-height: 20px;
            margin-bottom: 5px;
            .left {
              width: 70%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 15px;
              font-weight: 500;
              color: #333;
            }
            .right {
              position: absolute;
              right: 10px;
              text-align: right;
              font-size: 11px;
              color: var(--main-color);
            }
          }
          .content {
            display: flex;
            font-size: 11px;
            color: #666;
            line-height: 16px;
          }
          .risk {
            display: flex;
            font-size: 12px;
            color: #999;
            line-height: 16px;
          }
        }
      }
  }
  .btn {
    width: 90%;
    height: 60px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 100%;
      height: 100%;
    }
    .txt {
      position: absolute;
      font-size: 16px;
      color: #fff;
      top: 22px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    img {
      position: fixed;
      top: 25px;
      left: 78px;
    }
  }
  .fix_bg {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
  }
  .box {
    position: absolute;
    top: 5vh;
    width: 100%;
    height: 95vh;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background: #fff;
    font-size: 14px;
    padding: 25px 20px 20px;
    .confirm_btn {
      color: #d8ad3c;
    }
  }
  .top {
    // margin: 30px 17px;
    .p_item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 20px;
      label {
        display: inline-block;
        text-align: left;
        margin-right: 20px;
      }

      textarea {
        margin-top: 14px;
        box-sizing: border-box;
        border: 0;
        background: #f5f5f5;
        width: 100%;
        border-radius: 4px;
        resize: none;
        padding-top: 12px;
        padding-left: 14px;
        color: #666 !important;
        font-size: 14px;
        &:focus {
          outline: none;
        }         
      }
      textarea:disabled {
        color: #333 !important;
      }
      .post_imgs {
        display: flex;
        justify-content: space-between;
        margin-top: 14px;
        width: 100%;
        .post_img {
          width: 105px;
          height: 159px;
          margin-right: 7px;
          border-radius: 10px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    .empty {
      width: 20px;
    }
    button {
      border: 0;
      background: #fff;
      font-size: 14px;
      &:first-child {
        flex: 1;
        height: 45px;
        color: var(--main-color);
        border-radius: 7px;
        border: 1px solid var(--main-color);
      }
      &:last-child {
        flex: 1;
        color: #fff;
        width: 188px;
        height: 45px;
        background: var(--background-color);
        border-radius: 7px;
      }
      &:focus {
        outline: none;
      }
    }
  }
  .scale_poster {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 0.4);
    .inner_scale_poster {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 350px;
      height: 600px;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        border-radius: 20px;
        width: 300px;
        height: 430px;
        margin-bottom: 10px;
      }
      .poster-tip {
        font-size: 14px;
      }
    }
  }
}
.page_2 {
  height: 100vh;
}

</style>

